import { BindAll } from 'lodash-decorators'
import { action, computed, observable } from 'mobx'
import { $service } from '@xt/client/experimental/request/service'
import { EnumApiHomework } from '@xt/client/api'
import { MomentSourceType } from '@xt/client/enums'
import lodash, { head } from 'lodash'

/**
 * 旧的公开课数据 也是ui数据
 */
export type PublicCourseItem = {
  commentCount: number
  id: number | string
  likeCount: number
  liked: boolean
  publishTime: number
  title: string
  summary: string
  videoCoverUrl: string
  videoUrl: string
  viewCount: number
}

type AllMomentItem = {
  commentCount: number
  id: string
  like: boolean | null
  likeCount: number | null
  createTime: number
  title: string
  content: string
  videoUrl: string
  pictures: Array<{
    waterUrl: string
    originUrl: string
    originWidth: number
    originHeight: number
  }>
  viewCount: number | null
}

@BindAll()
export class PublicCourse {
  @observable list: PublicCourseItem[] = []

  @computed get chunckedList() {
    return lodash.chunk(this.list, 2)
  }

  @computed get chunckedListPc() {
    return lodash.chunk(this.list, 4)
  }

  public async loadPublicCourse(idList: string[]) {
    const [error, list] = await $service<AllMomentItem[]>({
      url: EnumApiHomework.QueryMomentListByIds,
      method: 'GET',
      params: {
        ids: idList.join(',')
      }
    })

    if (error) return

    this.updatePublicCourse(this.transformData(list), idList)
  }

  private transformData(moment: AllMomentItem[]): PublicCourseItem[] {
    return moment.map(item => {
      return {
        commentCount: item.commentCount,
        id: item.id,
        likeCount: typeof item.likeCount === 'number' ? item.likeCount : 0,
        liked: item.like === true,
        publishTime: item.createTime,
        title: item.title,
        summary: item.content,
        videoCoverUrl: head(item.pictures)?.originUrl ?? head(item.pictures)?.waterUrl ?? '',
        videoUrl: item.videoUrl,
        viewCount: typeof item.viewCount === 'number' ? item.viewCount : 0
      } satisfies PublicCourseItem
    })
  }

  @action
  private updatePublicCourse(list: PublicCourseItem[], orderIds: string[]) {
    // 需要根据orderIds排序
    const result: Array<PublicCourseItem> = []

    orderIds.forEach(id => {
      const item = list.find(i => i.id === id)

      if (item) {
        result.push(item)
      }
    })

    // 只取前4个展示
    this.list = result.slice(0, 4)
  }
}
